import { GenericObject, copyFields } from '@synergy/models';
import { PaginatedResponse } from '@synergy/api';

import { Demand } from '../../demands/models/demand';
import { Inquiry } from '../../inquiries/models/inquiry';
import { Invoice } from '../../invoices/models/invoice';
import { PurchaseOrder } from '../../purchase-orders/models/purchaseOrder';
import { SalesOrder } from '../../sales-orders/models/salesOrder';

export class SearchResult {
    public inquiries!: PaginatedResponse<Inquiry>;
    public salesOrders!: PaginatedResponse<SalesOrder>;
    public purchaseOrders!: PaginatedResponse<PurchaseOrder>;
    public demands!: PaginatedResponse<Demand>;
    public invoices!: PaginatedResponse<Invoice>;

    public static fromPlainObject(object: GenericObject): SearchResult {
        const result = new SearchResult();

        copyFields(object, result);

        if (object['inquiries']) {
            result.inquiries.items = object['inquiries'].items.map(Inquiry.fromPlainObject);
        }

        if (object['salesOrders']) {
            result.salesOrders.items = object['salesOrders'].items.map(SalesOrder.fromPlainObject);
        }

        if (object['purchaseOrders']) {
            result.purchaseOrders.items = object['purchaseOrders'].items.map(PurchaseOrder.fromPlainObject);
        }

        if (object['demands']) {
            result.demands.items = object['demands'].items.map(Demand.fromPlainObject);
        }

        if (object['invoices']) {
            result.invoices.items = object['invoices'].items.map(Invoice.fromPlainObject);
        }

        return result;
    }
}
